import { render, staticRenderFns } from "./EditProfileContent.vue?vue&type=template&id=8c765aea&scoped=true&"
import script from "./EditProfileContent.vue?vue&type=script&lang=js&"
export * from "./EditProfileContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c765aea",
  null
  
)

export default component.exports